<template>
  <BaseTypeNewForm
    base-type="events"
    title="Neue Veranstaltung anlegen"
    subtitle="Vergeben Sie einen Titel – Zeitraum, Inhalte und Vermarktung pflegen Sie anschließend im Editor."
    legend="Veranstaltung benennen"
    input-label="Titel der Veranstaltung"
    hint="Tipp: Ein klarer Titel hilft Gästen, Ihre Veranstaltung in der Übersicht schneller wiederzufinden."
    submit-label="Veranstaltung anlegen und bearbeiten"
    cancel-route-name="events.index"
    :edit-route-name="editRouteName"
  >
    <template #alert>
      <div class="alert alert-info mb-0">
        Wenn Ihre Veranstaltung bereits bei <strong>eventim</strong> und/oder <strong>Reservix/AdTicket</strong> gelistet ist, kontaktieren Sie uns bitte direkt statt eine neue Veranstaltung anzulegen.
      </div>
    </template>
  </BaseTypeNewForm>
</template>

<script>
import BaseTypeNewForm from "@/components/base_type/BaseTypeNewForm.vue";
import {ROUTES} from "@/stores/constants";

export default {
  components: {
    BaseTypeNewForm,
  },
  computed: {
    editRouteName() {
      return ROUTES.EVENTS.EDIT
    },
  },
}
</script>
